module.exports = __webpack_public_path__ + "static/media/tChartMultiTime.5a41f368.png";